"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixUserService = void 0;
class MatrixUserService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    async login(user, password, deviceId) {
        return this.httpClient.post('/login', {
            type: 'm.login.password',
            identifier: {
                type: 'm.id.user',
                user
            },
            password,
            device_id: deviceId
        });
    }
}
exports.MatrixUserService = MatrixUserService;
//# sourceMappingURL=MatrixUserService.js.map